import {
    Modal,
    StandardModalBody,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import React from "react";
import { useHotkeysContext } from "react-hotkeys-hook";
import { HStack } from "@design-system/HStack/HStack";
import { Shortcut } from "@design-system/Shortcut/Shortcut";

interface KeyboardCommandsModalProps {
    onClose: () => void;
}

export const KeyboardCommandsModal = ({
    onClose,
}: KeyboardCommandsModalProps) => {
    const keys = useHotkeysContext();
    const shouldUseTwoColumns = keys.hotkeys.length > 16;

    return (
        <Modal
            variant="standard"
            show
            onClose={onClose}
            size={shouldUseTwoColumns ? "xl" : "lg"}
        >
            <StandardModalHeader>
                Keyboard shortcuts available on the current screen
            </StandardModalHeader>
            <StandardModalBody>
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: shouldUseTwoColumns
                            ? "auto 4fr auto 4fr"
                            : "auto 4fr",
                        gap: shouldUseTwoColumns ? "1rem" : "0.5rem",
                        gridAutoFlow: "row",
                        maxHeight: "60vh",
                        overflowY: "auto",
                    }}
                >
                    {keys.hotkeys.map((hotkey) => (
                        <React.Fragment key={hotkey.hotkey}>
                            <HStack as="span" className="mr-2">
                                <Shortcut keys={hotkey.hotkey} />
                            </HStack>
                            <span>{hotkey.description}</span>
                        </React.Fragment>
                    ))}
                </div>
            </StandardModalBody>
        </Modal>
    );
};
